import { addFake$ } from './intents'
import { fromJS } from 'immutable'

export const fake$ = addFake$.mapTo(state =>
  state.set(
    'samples',
    state.get('samples').push(
      fromJS({
        iteration: Math.floor(Date.now() / 1000),
        cost: 500.0,
        sample: (Math.random() * 0xffffffff).toString(36).toUpperCase(),
      })
    )
  )
)



// WEBPACK FOOTER //
// ./fake.js